import { requestJSON, POST } from '../request.js'

/**
 * 国家列表
 * @param data
 * @returns {*}
 */
export const countryList = (data)=> {
    return requestJSON({
        method: 'post',
        url: '/country/enableList',
        data: data
    });
};

/**
 * 提交
 * @param data
 * @returns {*}
 */
export const submitFun = (data)=> {
    return POST('/touch/add',data);
};



// WEBPACK FOOTER //
// ./src/request/api/submit.js